import React, { useState } from 'react';
import { FaSpinner, FaTrash, FaVideo } from 'react-icons/fa';
import resolveMediaUrl from '../utils/resolveMediaUrl';

const VideoManager = ({
    description,
    onDescriptionChange,
    videoError,
    videoPreview,
    videoRef,
    videoDuration,
    videoFileName,
    videoFileSize,
    isUploadingVideo,
    onRemoveVideo,
    onUploadVideo,
    formatTime,
    onLoadedMetadata
}) => {
    const [isDragOver, setIsDragOver] = useState(false);

    return (
        <div className="form-group mb-4">
            <label htmlFor="post-description" className="form-label">Post Description *</label>
            <textarea
                id="post-description"
                value={description}
                onChange={(event) => onDescriptionChange(event.target.value)}
                placeholder="Enter post description"
                className="form-control"
            />

            <label htmlFor="video-upload" className="form-label d-flex align-items-center mt-3">
                <FaVideo className="me-2" /> Upload Video
            </label>

            {videoError && (
                <div className="alert alert-danger py-2 px-3 mb-2">
                    <small><strong>Error:</strong> {videoError}</small>
                </div>
            )}

            {videoPreview ? (
                <div className="video-preview-container p-3 border rounded">
                    <div className="video-player mb-3">
                        <video
                            ref={videoRef}
                            src={resolveMediaUrl(videoPreview)}
                            onLoadedMetadata={onLoadedMetadata}
                            controls
                            style={{ width: '100%', maxHeight: '400px', borderRadius: '8px' }}
                        />
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <p className="mb-1 fw-bold">{videoFileName}</p>
                            <p className="text-muted small mb-0">
                                {(videoFileSize / (1024 * 1024)).toFixed(2)} MB
                                {videoDuration > 0 ? ` | ${formatTime(videoDuration)}` : ''}
                            </p>
                        </div>
                        <button type="button" onClick={onRemoveVideo} className="btn btn-danger btn-sm">
                            <FaTrash className="me-1" /> Remove
                        </button>
                    </div>
                </div>
            ) : (
                <div className="video-upload-container">
                    <label
                        className={`video-upload-area${isDragOver ? ' drag-over' : ''}`}
                        onDragOver={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            setIsDragOver(true);
                        }}
                        onDragLeave={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            setIsDragOver(false);
                        }}
                        onDrop={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            setIsDragOver(false);
                            const [file] = event.dataTransfer.files || [];
                            if (file) onUploadVideo(file);
                        }}
                    >
                        <input
                            id="video-upload"
                            type="file"
                            accept="video/mp4,video/webm,video/quicktime,video/x-msvideo"
                            onChange={(event) => {
                                const [file] = event.target.files || [];
                                if (file) onUploadVideo(file);
                            }}
                            style={{ display: 'none' }}
                            disabled={isUploadingVideo}
                            aria-label="Upload video file"
                        />

                        <div className="video-upload-icon-wrapper">
                            {isUploadingVideo
                                ? <FaSpinner className="video-upload-icon spinning" />
                                : <FaVideo className="video-upload-icon" />
                            }
                        </div>

                        <p className="video-upload-title">
                            {isDragOver ? 'Drop to upload' : 'Click to upload or drag and drop'}
                        </p>
                        <p className="video-upload-subtitle">
                            {isUploadingVideo ? 'Uploading…' : 'MP4 · WebM · MOV · AVI'}
                        </p>

                        <div className="video-upload-badge">
                            Max 100 GB
                        </div>
                    </label>
                </div>
            )}
        </div>
    );
};

export default VideoManager;
